export const translateText = (language, text) => {
    const { language_dictionary } = window.DriveServiceSpecials;

    if(language_dictionary && language_dictionary[text]) return language_dictionary[text];
    return text;
};
